import * as React from 'react'
import {Util} from 'yougile-util'
import {DivWithHint} from '../hint/hint'

interface Props {
  children?: React.ReactNode
}

const HelpHintBase = (props: Props) => {
  const {children} = props
  const bem = Util.bemFrom('help-hint')
  return <DivWithHint className={bem()} content={children} />
}

export const HelpHint = (props: Props) => {
  return <HelpHintBase {...props} />
}
